import React, { Component } from 'react';
import { connect } from 'react-redux';
import withRouter from '../../../lib/router/withRouter';
import { comparePrePropsAndNextProps } from '../../../lib/common';
import { appActions } from '../../../store/modules/app';
import { recommendProductActions } from '../../../store/modules/recommend/product';
import RecommendProductDetailWrap from '../../../views/recommend/product/detail/RecommendProductDetailWrap';

class RecommendProductDetailContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      recommendProductId: null,
      pagination: {
        pageNum: 0,
        pageSize: 20,
      },
    };
  }

  componentDidMount() {
    const { match } = this.props;
    if (match.params.id) {
      this.setState(
        {
          recommendProductId: Number(match.params.id),
        },
        () => this.fetchData(),
      );
    }
  }

  componentDidUpdate(prevProps) {
    const prevId = prevProps.match?.params?.id;
    const nextId = this.props.match?.params?.id;

    if (prevId !== nextId && nextId) {
      this.setState(
        { recommendProductId: Number(nextId) },
        () => this.fetchData(),
      );
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return comparePrePropsAndNextProps([
      [nextProps, this.props],
      [nextState, this.state],
    ]);
  }

  /**
   * 데이터 불러오기
   */
  fetchData = () => {
    const { getRecommendProductDetail } = this.props;

    getRecommendProductDetail({
      recommendProductId: this.state.recommendProductId,
      pagination: this.state.pagination,
    });
  };

  getList = (data) => {
    this.setState(
      {
        pagination: {
          pageNum: data.pagination.pageNum,
          pageSize: data.pagination.pageSize,
        },
      },
      () => this.fetchData(),
    );
  };

  getExcelDownload = () => {
    const { getRecommendProductDetailItemListExcelDownload } = this.props;

    getRecommendProductDetailItemListExcelDownload({
      recommendProductId: this.state.recommendProductId,
    });
  };

  render() {
    const { recommendProductDetail, getProductSubCategoryList } = this.props;

    return (
      <RecommendProductDetailWrap
        recommendProductDetail={recommendProductDetail}
        getProductSubCategoryList={getProductSubCategoryList}
        getExcelDownload={this.getExcelDownload}
        getList={this.getList}
        pagination={this.state.pagination}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    recommendProductDetail: state.recommendProduct.recommendProductDetail,
  };
};

const mapDispatchToProps = {
  getRecommendProductDetail: recommendProductActions.getRecommendProductDetail,
  getProductSubCategoryList: appActions.getProductSubCategoryList,
  getRecommendProductDetailItemListExcelDownload:
    recommendProductActions.getRecommendProductDetailItemListExcelDownload,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(RecommendProductDetailContainer));
